/*
 * ////////////////////////////////////////////////////////////////////////////////
 * //
 * // This software system consists of computer software and documentation.
 * // It contains trade secrets and confidential information which are proprietary
 * // to Everi Games Inc.  Its use or disclosure in whole or in part without
 * // the express written permission of Everi Games Inc. is prohibited.
 * //
 * // This software system is also an unpublished work protected under the copyright
 * // laws of the United States of America.
 * //
 * // Copyright © 2019 Everi Games Inc.  All Rights Reserved
 * //
 * ////////////////////////////////////////////////////////////////////////////////
 */
import { CultureID } from './CultureID';
import LocalActionBase from './LocalActionBase';
import LocalCollectionMember from './LocalCollectionMember';

/** @hidden */
// tslint:disable-next-line:typedef
const property = cc._decorator.property;

/** [[Local]] handler for setting visibility of nodes. */
@cc._decorator.ccclass
export default class LocalNodecomponent extends LocalActionBase
{
    private _nodeActiveStates: [LocalCollectionMember, boolean][] = [];
    private _cultureNodeMap: Map<CultureID, cc.Node[]> = new Map();

    /** @hidden */
    protected start(): void
    {
        super.start();

        this.nodeCollection.WithValue(collection =>
            {
                collection.Nodes.forEach(node => this.addNode(node));
            });
    }

    /** @hidden */
    protected onCultureChanged(cultureId: CultureID): void
    {
        const localNodes: cc.Node[] = this._cultureNodeMap.get(cultureId);
        if (!localNodes || localNodes.length < 1)
        {
            this.reset();
            return;
        }
        this._nodeActiveStates.forEach(nodeActiveState =>
            {
                this.setState(nodeActiveState[0], localNodes.indexOf(nodeActiveState[0].node) > -1);
            });
    }

    protected reset(): void
    {
        this._nodeActiveStates.forEach(nodeActiveState => this.setState(nodeActiveState[0], nodeActiveState[1]));
    }

    private setState(localMember: LocalCollectionMember, to: boolean): void
    {
        if (localMember.SetOpacity)
        {
            localMember.node.opacity = to ? 255 : 0;
        }
        else
        {
            localMember.node.active = to;
        }
    }

    private getState(localMember: LocalCollectionMember): boolean
    {
        return localMember.SetOpacity
            ? localMember.node.opacity > 0
            : localMember.node.active;
    }

    private addNode(node: cc.Node): void
    {
        const localMember: LocalCollectionMember = node.getComponent(LocalCollectionMember);
        if (!localMember) { return; }

        const nodes: cc.Node[] = this._cultureNodeMap.get(localMember.CultureId);
        if (nodes)
        {
            nodes.push(node);
        }
        else
        {
            this._cultureNodeMap.set(localMember.CultureId, [node]);
        }
        this._nodeActiveStates.push([localMember, this.getState(localMember)]);
    }
}
